/*
 * Copyright (c) 2020 TechnoL0g.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

import i18n from '@/i18n'
import CryptoJS from 'crypto-js';
import Chain from '@/services/chain';
import Explorer from '@/services/explorer';

export default {
  namespaced: true,

  state: {
    warning: true,
    language: '',
    pinEncrypted: null, // encrypted hash
    account: {
      address: null,
      secret: null,
      pubKey: null,
    },
    global: {},
    fees: {},
    currentNode: "wss://node.xbts.io/ws"
  },

  getters: {
    warning: state => state.warning,
    language: state => state.language,
    pinEncrypted: state => state.pinEncrypted,
    account: state => state.account,
    global: state => state.global,
    fees: state => state.fees,
  },

  mutations: {
    SET_RESET (state) {
      state.warning = true;
      state.language = '';
      state.pinEncrypted = null;
      state.account = {
        address: null,
        secret: null,
        pubKey: null,
      }
    },
    HIDE_WARNING (state) {
      state.warning = false
    },
    SET_LANGUAGE (state, payload) {
      state.language = payload
    },
    SET_PIN_ENC (state, payload) {
      // полученный хэш шифруем тем же хэшем
      const hash = CryptoJS.SHA384(payload).toString();
      state.pinEncrypted = (CryptoJS.AES.encrypt(hash, hash)).toString();
    },
    SET_ACCOUNT (state, payload) {
      const hashPin = CryptoJS.SHA384(payload.pin).toString();
      state.account = {
        address: payload.address,
        secret: (CryptoJS.AES.encrypt(payload.secret, hashPin)).toString(),
        pubKey: payload.pubKey
      }
    },
    SET_GLOBAL (state, payload) {
      state.global = payload
    },
    SET_FEES (state, payload) {
      state.fees = payload
    }
  },

  actions: {
    async init({ commit }, node =  "wss://node.xbts.io/ws") {
      return await Chain.init(node);
    },
    async holders({ commit }, value) {
      return await Chain.holders(value);
    },
    async getObjects({ commit }, ids = []) {
      //return await Chain.getObjects(ids); //load time 15.324 sec быстрее
      return await Explorer.getObjects(ids); // load time 18.681 sec
    },
    reset ({ commit }) {
      commit('SET_RESET')
    },
    async hideWarning ({ commit }) {
      commit('HIDE_WARNING');
    },
    setLanguage ({ commit }, value) {
      i18n.locale = value;
      commit('SET_LANGUAGE', value);
    },
    setPinEnc ({ commit }, value) {
      commit('SET_PIN_ENC', value)
    },
    setAccount ({ commit }, value) {
      commit('SET_ACCOUNT', value)
    },
    async setChainGlobal ({ commit }) {
      //const data = await Chain.globalProperties(); // WS
      const data = await Explorer.properties(); // RPC
      if (data) {
        commit('SET_GLOBAL', data);
        let fees = {};
        for (let i=0; i < data.parameters.current_fees.parameters.length; i++) {
          fees[data.parameters.current_fees.parameters[i][0]] = data.parameters.current_fees.parameters[i][1];
        }
        commit('SET_FEES', fees);
      }
    },
    async accountRegister({ commit }, values) {
      return await Chain.accountRegister(values);
    },

  }
}
